<app-modal [title]="'Registrar nuevo objetivo'">
    <app-form [formGroup]="saveForm">
      <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
        <div>
          <app-label for="param_periodo_id">
            Período
          </app-label>
          <app-select id="param_periodo_id" formControlName="param_periodo_id" placeholder="Seleccione un período" [options]="periodosOptions" />
        </div>

        <div>
          <app-label for="cli_contrato_id">
            Contrato
          </app-label>
          <app-select id="cli_contrato_id" formControlName="cli_contrato_id" placeholder="Sin contrato" [options]="contratosOptions" />
        </div>

        <div>
          <app-label for="cli_establecimiento_id">
            Establecimiento
          </app-label>
          <app-select id="cli_establecimiento_id" formControlName="cli_establecimiento_id" placeholder="Seleccione un establecimiento (opcional)" [options]="establecimientosOptions" />
        </div>

        <div>
          <app-label for="objetivo">
            Objetivo
          </app-label>
          <div class="flex gap-4 mt-2">
            <label class="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                formControlName="aspiracion"
                class="w-4 h-4 text-blue-600 focus:ring-blue-500"
              />
              <span class="text-sm text-gray-700 dark:text-gray-300">Aspiración</span>
            </label>
            <label class="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                formControlName="transferencia"
                class="w-4 h-4 text-blue-600 focus:ring-blue-500"
              />
              <span class="text-sm text-gray-700 dark:text-gray-300">Transferencia</span>
            </label>
          </div>
          @if (saveForm.hasError('objetivoRequerido') && saveForm.touched) {
            <p class="mt-1 text-sm text-error-500">Seleccione al menos un objetivo.</p>
          }
        </div>

        <div>
          <app-label for="cantidad_preneces_proyectadas">
            Cantidad de Preñeces Proyectadas
          </app-label>
          <app-input-field id="cantidad_preneces_proyectadas" type="number" min="0" formControlName="cantidad_preneces_proyectadas" />
        </div>

        <div>
          <app-label for="cantidad_donantes">
            Cantidad de Donantes
          </app-label>
          <app-input-field id="cantidad_donantes" type="number" min="0" formControlName="cantidad_donantes" />
        </div>
      </div>
    </app-form>

    <app-creation-buttons *hasPermission="'clientes:create'"
      [valid]="saveForm.valid"
      [process]="loading"
      (onCreateClick)="create()"
      (onCancelClick)="cancel()"
    />
</app-modal>
